import React from "react";
import { colors2, UI_BODY_BOLD } from "oolib";
import {
  StyledContainer,
  StyledHeader,
  StyledTitleWrapper,
  StyledHeaderRight,
  StyledBody,
} from "./styled";
import { BlurNoteOverlay } from "../BlurNoteOverlay";

/**
 * `blurNote`: when set, the body renders blurred and inert behind this note
 * (BlurNoteOverlay), with the header left as is. `blurNoteIcon` is the
 * phosphor icon on the note.
 */
export const DashboardWidgetShell = ({
  title,
  titleJSX,
  headerRight,
  children,
  style = {},
  bodyStyle = {},
  blurNote,
  blurNoteIcon,
}) => {
  return (
    <StyledContainer style={style}>
      <StyledHeader>
        {titleJSX ? 
          titleJSX : 
            <StyledTitleWrapper>
                <UI_BODY_BOLD style={{ color: colors2.grey80 }}>{title}</UI_BODY_BOLD>
            </StyledTitleWrapper>
        }
        {headerRight && <StyledHeaderRight>{headerRight}</StyledHeaderRight>}
      </StyledHeader>
      <StyledBody style={bodyStyle}>
        <BlurNoteOverlay note={blurNote} icon={blurNoteIcon} style={{ height: "100%" }}>
          {children}
        </BlurNoteOverlay>
      </StyledBody>
    </StyledContainer>
  );
};
